<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform translate-y-10 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform translate-y-10 opacity-0"
  >
    <button
      v-show="showButton"
      class="fixed bottom-6 left-6 z-50 bg-gray-800 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 hover:shadow-xl transition-all duration-300 group"
      aria-label="Retourner en haut de la page"
      @click="scrollToTop"
    >
      <ArrowUpIcon class="h-5 w-5 transform group-hover:-translate-y-0.5 transition-transform duration-300" />
    </button>
  </Transition>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from 'vue';
import { ArrowUp as ArrowUpIcon } from 'lucide-vue-next';

export default defineComponent({
  name: 'ScrollToTop',
  
  components: {
    ArrowUpIcon
  },

  setup() {
    const showButton = ref(false);
    let lastScrollPosition = 0;
    
    const checkScroll = () => {
      const currentScrollPosition = window.scrollY;
      // Afficher le bouton si on a scrollé plus de 200px ET qu'on scrolle vers le bas
      showButton.value = currentScrollPosition > 200 && currentScrollPosition > lastScrollPosition;
      lastScrollPosition = currentScrollPosition;
    };

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    onMounted(() => {
      window.addEventListener('scroll', checkScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', checkScroll);
    });

    return {
      showButton,
      scrollToTop
    };
  }
});
</script> 